import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent {
  @Input() placeholder = 'Tapez votre recherche';
  @Output() onSearch = new EventEmitter<string>();

  searchValue = '';

  search() {
    if (this.searchValue.trim()) {
      this.onSearch.emit(this.searchValue);
    }
  }
}
